const EventBus = window.EventBus;
export const NewAdvancedSearch = {
  props: [
    'priceInitialRange',
    'minPrice',
    'maxPrice',
    'mileageInitialRange',
    'minMileage',
    'maxMileage',
    'paymentInitialRange',
    'paymentFrequency',
    'carprooflinkInitialRange',
    'minCarprooflink',
    'maxCarprooflink',
    'dryweightInitialRange',
    'minDryweight',
    'maxDryweight',
    'grossweightInitialRange',
    'minGrossweight',
    'maxGrossweight',
    'sleepcapacityInitialRange',
    'minSleepcapacity',
    'maxSleepcapacity',
    'slug',
    'initOpened',
    'initialStocknumber',
    'initialFilter',
    'urlParams',
    'contentdir',
    'gutembergOptions',
    'vehicleFound',
    'packageRegex',
    'sortMakesAlphabetically',
    'collapseDesktop',
    'isUpperBar',
    'locationOrder',
  ],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      tags: [],
      payloadtags: [],
      isMobile: false,
      isTablet: false,
      isActive: false,
      filterValue: this.initialFilter,
      searchOpened: false,
      stockNumber: this.initialStocknumber,
      priceRange: this.priceInitialRange || [0, 9999999],
      mileageRange: this.mileageInitialRange || [0, 9999999],
      carprooflinkRange: this.carprooflinkInitialRange || [0, 9999999],
      paymentRange: (this.paymentInitialRange && this.paymentInitialRange[0] != null && this.paymentInitialRange[1] != null) ? this.paymentInitialRange : [0, 0],
      dryweightRange: this.dryweightInitialRange || [0, 9999999],
      grossweightRange: this.grossweightInitialRange || [0, 9999999],
      sleepcapacityRange: this.sleepcapacityInitialRange || [0, 999],
      minPayment: 0,
      maxPayment: 0,
      enableCross: false,
      tooltipMerge: false, // true: unifies tooltip boxes false: each box follows de dot range
      urlToGo: '',
      vehiclesCount: 0,
      inStockCount: 0,
      incomingCount: 0,
      filteredInventory: [],
      pivotList: [],
      initialResultset: [],
      loadingInventory: false,
      options: {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        drivetrains: [],
        status: [],
        boxsizes: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        certifieds: [],
        specials: [],
        demos: [],
        asiss: [],
        stocks: [],
        lots: [], 
        fueltypes: [],
        seats: [],
      },
      optionsCount: {
        conditions: {},
        years: {},
        makes: {},
        models: {},
        trims: {},
        colours: {},
        bodystyles: {},
        features: {},
        transmissions: {},
        status: {},
        boxsizes: {},
        drivetrains: {},
        enginedisplacements: {},
        packages: {},
        locations: {},
        engines: {},
        types: {},
        subtypes: {},
        productlines: {},
        outsidelengths: {},
        floorplans: {},
        salependings: {},
        demos: {},
        asiss: {},
        certifieds: {},
        specials: {},
        stocks: {},
        lots: {}, 
        fueltypes: {},
        seats: {},
      },
      selected: {
        condition: [],
        year: [],
        make: [],
        model: [],
        trim: [],
        colour: [],
        bodystyle: [],
        feature: [],
        transmission: [],
        drivetrain: [],
        status: [],
        boxsize: [],
        enginedisplacement: [],
        package: [],
        location: [],
        engine: [],
        type: [],
        subtype: [],
        productline: [],
        outsidelength: [],
        floorplan: [],
        salepending: [],
        demo: [],
        asis: [],
        certified: [],
        special: [],
        stock: [],
        lot: [], 
        fueltype: [],
        seats: [],
      },
      postOptions: {
        models: [],
        trims: [],
        types: [],
        subtypes: []
      },
      aux: {
        trims: []
      },
      pleaseSelectAModel: true,
      pleaseSelectAMake: true,
      initialZero: true,
      lastFilteredOptions: {},
      clearing: false,
    }
  },
  created() {
    if (this.vehicleFound) {
      this.loadingInventory = true;
      window.location.href = this.vehicleFound;
    } else {
      this.httpRequestInventory();
      this.changeClass();
      this.searchOpened = this.initOpened;
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function () {
    // Calls the method before page loads
    this.selected = {
      condition: this.urlParams.conditions || [],
      year: this.urlParams.years || [],
      make: this.urlParams.makes || [],
      lot: this.urlParams.lots || [],
      model: this.urlParams.models || [],
      type: this.urlParams.types || [],
      subtype: this.urlParams.subtypes || [],
      productline: this.urlParams.productlines || [],
      outsidelength: this.urlParams.outsidelengths || [],
      floorplan: this.urlParams.floorplans || [],
      trim: this.urlParams.trims || [],
      colour: this.urlParams.color || [],
      bodystyle: this.urlParams.bodystyles || [],
      transmission: this.urlParams.transmissions || [],
      drivetrain: this.urlParams.drivetrains || [],
      status: this.urlParams.status || [],
      boxsize: this.urlParams.boxsizes || [],
      salepending: this.urlParams.salependings || [],
      stock: this.urlParams.stocks || [],
      enginedisplacement: this.urlParams.enginedisplacements || [],
      package: this.urlParams.package || [],
      engine: this.urlParams.engines || [],
      location: this.urlParams.location || [],
      feature: this.urlParams.searchables || [],
      demo: this.urlParams.demos || [],
      asis: this.urlParams.asiss || [],
      certified: this.urlParams.certifieds || [],
      special: this.urlParams.specials || [],
      fueltype: this.urlParams.fueltypes || [],
      seat: this.urlParams.seats || [],
    };

    if(!this.isUpperBar) {
      this.sendFilterOptions(window.location.href);
    }

    EventBus.$on('variablesUpdate', (variables) => {
      Object.keys(variables).forEach(key => {
        this[key] = variables[key];
      });
    }); 
  },
  methods: {
    shouldShow() {
      return this.isTablet || this.colapseDesktop;
    },
    getPaymentRange() {
      if (this.filteredInventory) {
        let paymentFrequency = this.paymentFrequency.toLowerCase() || 'biweekly';
    
        // Inicializar con valores extremos para asegurarse de que se actualicen correctamente
        let minPayment = Infinity;
        let maxPayment = -Infinity;
    
        this.filteredInventory.forEach(item => {
          if (item.payments && item.payments[paymentFrequency]) {
            let payment = item.payments[paymentFrequency];
            
            // Comparar para encontrar el valor mínimo y máximo
            if (payment < minPayment) {
              minPayment = payment;
            }
            if (payment > maxPayment) {
              maxPayment = payment;
            }
          }
        });
    
        // Asignar los valores nuevos de rango
        if(minPayment != Infinity && maxPayment != -Infinity) {
          this.minPayment = minPayment;
          this.maxPayment = maxPayment;

          if(this.paymentInitialRange && ((this.paymentInitialRange[0] === null && this.paymentInitialRange[1] === null) || (this.paymentInitialRange[0] === 0 && this.paymentInitialRange[1] === 0))){
            this.paymentRange = [minPayment, maxPayment];
          }
          else{
            this.paymentRange = this.paymentInitialRange;
          }
        }
      }
    },       
    moreThanZero(array) {
      return array.length > 0;
    },
    changeClass() {
      setTimeout(() => this.isActive = true, 100)
    },
    httpRequestInventory() {
      this.loadingInventory = true;
      EventBus.httpRequestInventory(this.contentdir, this.entryPoint, this.gutembergOptions);
    },
    entryPoint(inventory) {
      this.initialResultset = inventory;
      this.loadingInventory = false;
      this.options = this.getOptions(this.initialResultset);
      if (inventory && inventory.length <= 0) {
        this.searchOpened = false;
      }
      this.updateVehiclesCount();
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.refreshSliders();
    },
    toggleAdvancedSearch() {
      this.searchOpened = !this.searchOpened;

       this.$nextTick(() => {
        this.refreshSliders();
      }); 
    },
    clearOptions() {
      var options = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        status: [],
        boxsizes: [],
        drivetrains: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        demos: [],
        asiss: [],
        certifieds: [],
        specials: [],
        stocks: [],
        lots: [],
        fueltypes: [],
        seats: [],
      }
      return options;
    },
    getOptions(inventory) {
      // clear all options
      var options = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        trims: [],
        colours: [],
        bodystyles: [],
        features: [],
        transmissions: [],
        status: [],
        boxsizes: [],
        drivetrains: [],
        enginedisplacements: [],
        packages: [],
        locations: [],
        engines: [],
        types: [],
        subtypes: [],
        productlines: [],
        outsidelengths: [],
        floorplans: [],
        salependings: [],
        demos: [],
        asiss: [],
        certifieds: [],
        specials: [],
        stocks: [],
        lots: [], 
        fueltypes: [],
        seats: [],
      }

      Object.values(inventory).forEach(item => {

        if (item.condition && !options.conditions.includes(item.condition)) {
          options.conditions.push(item.condition)
          this.optionsCount.conditions[item.condition] = 1;
        }
        else {
          this.optionsCount.conditions[item.condition]++;
        }
        if (item.year && !options.years.includes(item.year)) {
          options.years.push(item.year)
          this.optionsCount.years[item.year] = 1;
        }
        else {
          this.optionsCount.years[item.year]++;
        }

        if (item.salepending) {
          if (!options.salependings.includes("1")) {
            options.salependings.push("1")
            this.optionsCount.salependings["1"] = 1;
          } else {
            this.optionsCount.salependings["1"]++;
          }
        }

        if (!item.salepending) {
          if (!options.salependings.includes("0")) {
            options.salependings.push("0")
            this.optionsCount.salependings["0"] = 1;
          } else {
            this.optionsCount.salependings["0"]++;
          }
        }

        if (item.demo) {
          if (!options.demos.includes("1")) {
            options.demos.push("1")
            this.optionsCount.demos["1"] = 1;
          } else {
            this.optionsCount.demos["1"]++;
          }
        }

        if (item.asis) {
          if (!options.asiss.includes("1")) {
            options.asiss.push("1")
            this.optionsCount.asiss["1"] = 1;
          } else {
            this.optionsCount.asiss["1"]++;
          }
        }

        if (item.certified) {
          if (!options.certifieds.includes("1")) {
            options.certifieds.push("1")
            this.optionsCount.certifieds["1"] = 1;
          } else {
            this.optionsCount.certifieds["1"]++;
          }
        }

        if (item.special) {
          if (!options.specials.includes("1")) {
            options.specials.push("1")
            this.optionsCount.specials["1"] = 1;
          } else {
            this.optionsCount.specials["1"]++;
          }
        }

        if(item.seats && item.seats > 0){
          if (!options.seats.includes(item.seats.toString())) {
            options.seats.push(item.seats.toString())
            this.optionsCount.seats[item.seats.toString()] = 1;
          }
          else {
            this.optionsCount.seats[item.seats.toString()]++;
          }
        }

        if (item.stocknumber && !options.stocks.includes(item.stock)) {
          options.stocks.push(item.stocknumber)
          this.optionsCount.stocks[item.stocknumber] = 1;
        }
        else {
          this.optionsCount.stocks[item.stocknumber]++;
        }


        if (item.make && !options.makes.includes(item.make.toUpperCase())) {
          options.makes.push(item.make.toUpperCase())
          this.optionsCount.makes[item.make.toUpperCase()] = 1;
        }
        else if (item.make)
          this.optionsCount.makes[item.make.toUpperCase()]++;


        if (item.lot && !options.lots.includes(item.lot.toUpperCase())) {
          options.lots.push(item.lot.toUpperCase())
          this.optionsCount.lots[item.lot.toUpperCase()] = 1;
        }
        else if (item.lot)
          this.optionsCount.lots[item.lot.toUpperCase()]++;

        if (item.model && !options.models.includes(item.model.toUpperCase())) {
          options.models.push(item.model.toUpperCase())
          this.optionsCount.models[item.model.toUpperCase()] = 1;
        }
        else if (item.model)
          this.optionsCount.models[item.model.toUpperCase()]++;

        if (item.trim && !options.trims.includes(item.trim.toUpperCase())) {
          options.trims.push(item.trim.toUpperCase())
          this.optionsCount.trims[item.trim.toUpperCase()] = 1;
        }
        else if (item.trim)
          this.optionsCount.trims[item.trim.toUpperCase()]++;

        if (item.exteriorcolor && !options.colours.includes(item.exteriorcolor.toUpperCase())) {
          options.colours.push(item.exteriorcolor.toUpperCase())
          this.optionsCount.colours[item.exteriorcolor.toUpperCase()] = 1;
        }
        else if (item.exteriorcolor)
          this.optionsCount.colours[item.exteriorcolor.toUpperCase()]++;

        if (item.bodystyle && !options.bodystyles.includes(item.bodystyle)) {
          options.bodystyles.push(item.bodystyle)
          this.optionsCount.bodystyles[item.bodystyle] = 1;
        }
        else if (item.bodystyle)
          this.optionsCount.bodystyles[item.bodystyle]++;


        if (item.fueltype && !options.fueltypes.includes(item.fueltype.toUpperCase())) {
          options.fueltypes.push(item.fueltype.toUpperCase())
          this.optionsCount.fueltypes[item.fueltype.toUpperCase()] = 1;
        }
        else if (item.fueltype)
          this.optionsCount.fueltypes[item.fueltype.toUpperCase()]++;


        if (item.transmission && !options.transmissions.includes(item.transmission)) {
          options.transmissions.push(item.transmission)
          this.optionsCount.transmissions[item.transmission] = 1;
        }
        else {
          this.optionsCount.transmissions[item.transmission]++;
        }

        if (item.drivetrain && !options.drivetrains.includes(item.drivetrain.toUpperCase())) {
          options.drivetrains.push(item.drivetrain.toUpperCase())
          this.optionsCount.drivetrains[item.drivetrain.toUpperCase()] = 1;
        }
        else if (item.drivetrain)
          this.optionsCount.drivetrains[item.drivetrain.toUpperCase()]++;

        if (item.boxsize && !options.boxsizes.includes(item.boxsize.toUpperCase())) {
          options.boxsizes.push(item.boxsize.toUpperCase())
          this.optionsCount.boxsizes[item.boxsize.toUpperCase()] = 1;
        }
        else if (item.boxsize)
          this.optionsCount.boxsizes[item.boxsize.toUpperCase()]++;

        if (item.location && !options.locations.includes(item.location.toUpperCase())) {
          options.locations.push(item.location.toUpperCase())
          this.optionsCount.locations[item.location.toUpperCase()] = 1;
        }
        else if (item.location)
          this.optionsCount.locations[item.location.toUpperCase()]++;

        if (item.engine && !options.engines.includes(item.engine.toUpperCase())) {
          options.engines.push(item.engine.toUpperCase())
          this.optionsCount.engines[item.engine.toUpperCase()] = 1;
        }
        else if (item.engine)
          this.optionsCount.engines[item.engine.toUpperCase()]++;

        /*----------- STATUS FILTER ------------------  */

        if (item.incoming) {
          if (!options.status.includes("INCOMING")) {
            options.status.push("INCOMING")
            this.optionsCount.status["INCOMING"] = 1;
            this.incomingCount = 1;
          } else {
            this.optionsCount.status["INCOMING"]++;
            this.incomingCount++;
          }
        }

        if (!item.incoming) {
          if (!options.status.includes("IN STOCK")) {
            options.status.push("IN STOCK")
            this.optionsCount.status["IN STOCK"] = 1;
            this.inStockCount = 1;
          } else {
            this.optionsCount.status["IN STOCK"]++;
            this.inStockCount++;
          }
        }

        if (item.special) {
          if (!options.status.includes("SPECIAL")) {
            options.status.push("SPECIAL")
            this.optionsCount.status["SPECIAL"] = 1;
          } else {
            this.optionsCount.status["SPECIAL"]++;
          }
        }

        if (item.demo) {
          if (!options.status.includes("DEMO")) {
            options.status.push("DEMO")
            this.optionsCount.status["DEMO"] = 1;
          } else {
            this.optionsCount.status["DEMO"]++;
          }
        }

        if (item.asis) {
          if (!options.status.includes("AS IS")) {
            options.status.push("AS IS")
            this.optionsCount.status["AS IS"] = 1;
          } else {
            this.optionsCount.status["AS IS"]++;
          }
        }

        if (item.salepending) {
          if (!options.status.includes("SALE PENDING")) {
            options.status.push("SALE PENDING")
            this.optionsCount.status["SALE PENDING"] = 1;
          } else {
            this.optionsCount.status["SALE PENDING"]++;
          }
        }

        if (item.certified) {
          if (!options.status.includes("CERTIFIED")) {
            options.status.push("CERTIFIED")
            this.optionsCount.status["CERTIFIED"] = 1;
          } else {
            this.optionsCount.status["CERTIFIED"]++;
          }
        }

        /* ------- END STATUS FILTER ------------------- */

        if (item.enginedisplacement && !options.enginedisplacements.includes(item.enginedisplacement.toString())) {
          options.enginedisplacements.push(item.enginedisplacement.toString())
          this.optionsCount.enginedisplacements[item.enginedisplacement] = 1;
        }
        else {
          this.optionsCount.enginedisplacements[item.enginedisplacement]++;
        }
        if (item.type && !options.types.includes(item.type)) {
          options.types.push(item.type)
          this.optionsCount.types[item.type] = 1
        }
        else {
          this.optionsCount.types[item.type]++;
        }
        if (item.subtype && !options.subtypes.includes(item.subtype)) {
          options.subtypes.push(item.subtype)
          this.optionsCount.subtypes[item.subtype] = 1
        }
        else {
          this.optionsCount.subtypes[item.subtype]++;
        }
        if (item.productline && !options.productlines.includes(item.productline)) {
          options.productlines.push(item.productline)
          this.optionsCount.productlines[item.productline] = 1
        }
        else {
          this.optionsCount.productlines[item.productline]++;
        }
        if (item.outsidelength) {
          if (item.outsidelength && !options.outsidelengths.includes(item.outsidelength)) {
            options.outsidelengths.push(item.outsidelength)
            this.optionsCount.outsidelengths[item.outsidelength] = 1
          }
          else {
            this.optionsCount.outsidelengths[item.outsidelength]++;
          }
        }
        if (item.floorplantags) {
          var search = item.floorplantags
          for (var i in search) {
            if (!options.floorplans.includes(search[i])) {
              options.floorplans.push(search[i])
              this.optionsCount.floorplans[search[i]] = 1;
            }
            else {
              this.optionsCount.floorplans[search[i]]++;
            }
          }
        }
        let searchableArrAlreadyIterated = [];
        for (var k in item.searchablesarray) {
          if (!options.features.includes(item.searchablesarray[k])) {
            options.features.push(item.searchablesarray[k])
            this.optionsCount.features[item.searchablesarray[k]] = 1;
          }
          else {
            if (!searchableArrAlreadyIterated.includes(item.searchablesarray[k]))
              this.optionsCount.features[item.searchablesarray[k]]++;
          }
          searchableArrAlreadyIterated.push(item.searchablesarray[k]);
        }
        if (typeof item.searchables !== "undefined" && item.searchables.length > 0) {
          var searchablesExploded = item.searchables.split(',');
          var regex = new RegExp(this.packageRegex);
          for (var j in searchablesExploded) {
            if (searchablesExploded[j].match(regex) && !options.packages.includes(searchablesExploded[j])) {
              options.packages.push(searchablesExploded[j])
              this.optionsCount.packages[searchablesExploded[j]] = 1;
            }
            else if (searchablesExploded[j].match(regex) && options.packages.includes(searchablesExploded[j]))
              this.optionsCount.packages[searchablesExploded[j]]++
          }

        }
      })

      options.conditions.sort();
      options.years.sort().reverse();
      options.salependings.sort();
      options.demos.sort();
      options.asiss.sort();
      options.certifieds.sort();
      options.specials.sort();
      options.stocks.sort();

      if(this.sortMakesAlphabetically){
        options.makes.sort();
      }else{
        if (options.makes.length > 0) {
          var listMakes = this.optionsCount.makes;
          options.makes.sort(function (a, b) {
            return (listMakes[a] < listMakes[b]) ? 1 : ((listMakes[a] > listMakes[b]) ? -1 : ((a > b) ? 1 : ((a < b) ? -1 : 0)));
          });
        }
      }

      /* Sorting locations by specific order */
      if(this.locationOrder && this.locationOrder.length > 0){
        const orderLC = this.locationOrder.map(s => s.trim().toLowerCase());

        const rank = new Map(orderLC.map((v, i) => [v, i]));

        options.locations.sort((a, b) => {
          const ia = rank.has(a.toLowerCase()) ? rank.get(a.toLowerCase()) : Infinity;
          const ib = rank.has(b.toLowerCase()) ? rank.get(b.toLowerCase()) : Infinity;

          if (ia !== ib) return ia - ib;
          return a.localeCompare(b);
        });

      }else{
        options.locations.sort();
      }

      options.lots.sort();
      options.models.sort();
      options.trims.sort();
      options.colours.sort();
      options.bodystyles.sort();
      options.features.sort();
      options.transmissions.sort();
      options.status.sort();
      options.drivetrains.sort();
      options.boxsizes.sort();
      options.enginedisplacements.sort();
      options.packages.sort();
      options.types.sort();
      options.subtypes.sort();
      options.productlines.sort();
      options.outsidelengths.sort();
      options.floorplans.sort();
      options.engines.sort();
      options.fueltypes.sort();
      options.seats.sort();

      this.pivotList.forEach(item => {
        options[item] = this.options[item];
      })

      return options;
    },
    buildUrl(keepSort = true) {
      let url = '';

      if (this.stockNumber) {
        url += '/stocknumber/' + this.stockNumber;
      }

      if (this.priceRange) {
        if (this.minPrice != this.priceRange[0] ||
          this.maxPrice != this.priceRange[1])
          url += '/price/' + this.priceRange[0] + '-' + this.priceRange[1];
      }

      if (this.carprooflinkRange) {
        if (this.minCarprooflink != this.carprooflinkRange[0] ||
          this.maxCarprooflink != this.carprooflinkRange[1])
          url += '/towing/' + this.carprooflinkRange[0] + '-' + this.carprooflinkRange[1];
      }

      if (this.paymentRange) {
        if(this.minPayment != 0 && this.maxPayment != 0 && this.paymentRange[0] != 0 && this.paymentRange[1] != 0) {
          if (this.minPayment != this.paymentRange[0] ||
            this.maxPayment != this.paymentRange[1])
            url += '/payment/' + this.paymentRange[0] + '-' + this.paymentRange[1];
        }
      }

      if (this.mileageRange) {
        if (this.minMileage != this.mileageRange[0] ||
          this.maxMileage != this.mileageRange[1])
          url += '/mileage/' + this.mileageRange[0] + '-' + this.mileageRange[1];
      }

      if (this.dryweightRange) {
        if (this.minDryweight >= 0 && this.dryweightRange && this.dryweightRange[0] >= 0 && this.maxDryweight
          && this.dryweightRange[1] >= 0 && (this.dryweightRange[0] > this.minDryweight || this.dryweightRange[1] < this.maxDryweight)) {
          url += '/dryweight/' + this.dryweightRange[0] + '-' + this.dryweightRange[1];
        }
      }

      if (this.grossweightRange) {
        if (this.minGrossweight >= 0 && this.grossweightRange && this.grossweightRange[0] >= 0 && this.maxGrossweight
          && this.grossweightRange[1] >= 0 && (this.grossweightRange[0] > this.minGrossweight || this.grossweightRange[1] < this.maxGrossweight)) {
          url += '/grossweight/' + this.grossweightRange[0] + '-' + this.grossweightRange[1];
        }
      }

      if (this.sleepcapacityRange) {
        if (this.minSleepcapacity >= 0 && this.sleepcapacityRange && this.sleepcapacityRange[0] >= 0 && this.maxSleepcapacity
          && this.sleepcapacityRange[1] >= 0 && (this.sleepcapacityRange[0] > this.minSleepcapacity || this.sleepcapacityRange[1] < this.maxSleepcapacity)) {
          url += '/sleepcapacity/' + this.sleepcapacityRange[0] + '-' + this.sleepcapacityRange[1];
        }
      }

      if (this.selected.condition.length > 0)
        url += '/condition/' + this.selected.condition.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.year.length > 0)
        url += '/year/' + this.selected.year.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.salepending.length > 0)
        url += '/salepending/' + this.selected.salepending.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.demo.length > 0)
        url += '/demo';
      if (this.selected.stock.length > 0)
        url += '/stock/' + this.selected.stock.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.make.length > 0)
        url += '/make/' + this.selected.make.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.lot.length > 0)
        url += '/lot/' + this.selected.lot.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.type.length > 0)
        url += '/type/' + this.selected.type.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.subtype.length > 0)
        url += '/subtype/' + this.selected.subtype.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.model.length > 0)
        url += '/model/' + this.selected.model.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.trim.length > 0)
        url += '/trim/' + this.selected.trim.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.transmission.length > 0)
        url += '/transmission/' + this.selected.transmission.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.status.length > 0)
        url += '/status/' + this.selected.status.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.drivetrain.length > 0)
        url += '/drivetrain/' + this.selected.drivetrain.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.boxsize.length > 0)
        url += '/boxsize/' + this.selected.boxsize.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/'/g, '[inch]').replace(/[/]/g, "_").toLowerCase()
      }).join(',');
      if (this.selected.enginedisplacement.length > 0)
        url += '/enginedisplacement/' + this.selected.enginedisplacement.map((item) => {
          return item.toString().replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.package.length > 0)
        url += '/package/' + this.selected.package.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.location.length > 0)
        url += '/location/' + this.selected.location.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.engine.length > 0)
        url += '/engine/' + this.selected.engine.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/®/g, '[reg]').replace(/–/g, '[-]').replace(/&/g, '[AND]').replace(/[/]/g, "_").replace(/\(/g, '[').replace(/\)/g, ']').replace(/\+/g, 'plus').replace(/\u00A0/g, '[x]').toLowerCase()
      }).join(',');
      if (this.selected.colour.length > 0)
        url += '/exteriorcolor/' + this.selected.colour.map((item) => {
          return encodeURIComponent(item.replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/[/]/g, "_").replace(/\(/g, '[').replace(/\)/g, ']').toLowerCase())
      }).join(',');
      if (this.selected.bodystyle.length > 0)
        url += '/bodystyle/' + this.selected.bodystyle.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.fueltype.length > 0)
        url += '/fueltype/' + this.selected.fueltype.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.filterValue && this.filterValue.length > 0){
        url += '/filter/' + this.filterValue.trim().replace(/ /g, '_').toLowerCase();
      }
      if (this.selected.feature.length > 0)
        url += '/option/' + this.selected.feature.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.productline.length > 0)
        url += '/productline/' + this.selected.productline.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.outsidelength.length > 0)
        url += '/length/' + this.selected.outsidelength.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');
      if (this.selected.floorplan.length > 0)
        url += '/floorplan/' + this.selected.floorplan.map((item) => {
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toLowerCase()
        }).join(',');

      if (this.selected.special.length > 0)
        url += '/special/' + this.selected.special[0];

      if (this.selected.certified.length > 0)
        url += '/certified/' + this.selected.certified[0];

      if (this.selected.seat.length > 0)
        url += '/seat/' + this.selected.seat.map((item) => { 
          return item.replace(/ /g, '-').replace(/-{2,}/g, '-').toString().toLowerCase()
        }).join(',');

      // SHIFT DIGITAL EVENTS
      if (document.getElementById("shiftdigital-script") != null) {
        if (this.selected.condition.length > 0 || 
            this.selected.year.length > 0 || 
            this.selected.make.length > 0 ||
            this.selected.model.length > 0 || 
            this.selected.trim.length > 0 ||
            this.selected.drivetrain.length > 0 || 
            this.selected.boxsize.length > 0 || 
            this.selected.colour.length > 0 || 
            this.selected.bodystyle.length > 0 || 
            this.selected.fueltype.length > 0 ||
            this.selected.feature.length > 0 ||
            (this.minPrice != this.priceRange[0] || this.maxPrice != this.priceRange[1]) ||
            (this.minMileage != this.mileageRange[0] || this.maxMileage != this.mileageRange[1]) ) {

          if (!sessionStorage.getItem('formEventts') || (Date.now() - sessionStorage.getItem('formEventts')) / 1000 > 2) {
            sessionStorage.setItem('formEventts', new Date().getTime());

            var statusLB = '';
            if (this.gutembergOptions && this.gutembergOptions.flags && this.gutembergOptions.flags == 'certified') {
              statusLB = 'CPO';
            }else if (this.gutembergOptions && this.gutembergOptions.status && this.gutembergOptions.status == 'New') {
              statusLB = 'New';
            }else if (this.selected.condition && this.selected.condition.length > 0 && this.selected.condition.includes('NEW')) {
              statusLB = 'New';
            } else if(this.gutembergOptions.status && this.gutembergOptions.status == 'Used' && this.searchStatusInInventory('certified') <= 0){
              statusLB = 'Used';
            }else {
              statusLB = 'Mixed';
            }

            let modelFilter = (this.selected.model.length > 0) ? this.selected.model.map((item) => {return item.toLowerCase()}).join('|') : 'all';

            setTimeout(() => {
              sendPvVl();
              sd('dataLayer', {
                countSearchResults: this.vehiclesCount,
                filterSearch: {
                  status: statusLB,
                  year: this.selected.year,
                  make: this.selected.make,
                  model: modelFilter,
                  trim: this.selected.trim,
                  color: this.selected.colour,
                  driveTrain: this.selected.drivetrain,
                  boxsize: this.selected.boxsize,
                  minPrice: this.priceRange[0],
                  maxPrice: this.priceRange[1],
                  bodyStyle: this.selected.bodystyle,
                  features: this.selected.feature,
                  fueltype: this.selected.fueltype
                },
                events: 'filterSearch'
              });
              sd('send');
            }, 300);

          }
        }
      }

      url += '/';
      var pathname = window.location.pathname;
      var query = window.location.search || '';
      pathname = this.clearParameters(pathname, keepSort);
      const path = (pathname + url).replace('//', '/');

      if(!this.clearing && !this.isUpperBar){
        this.sendFilterOptions(window.location.origin + path + query);
      }
      
      this.urlToGo = (pathname + url).replace('//', '/') + query;

    },
    sendFilterOptions(fullUrl){
      const filteredOptions = Object.keys(this.selected).reduce((acc, key) => {
        if (this.selected[key].length > 0) {
          acc[key] = this.selected[key].join(", ").toUpperCase();
        }
        return acc;
      }, {});

      if (JSON.stringify(filteredOptions) !== JSON.stringify(this.lastFilteredOptions)) {
        if(Object.keys(filteredOptions).length > 0) {
          if(!fullUrl){
            fullUrl = window.location.href;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'url': fullUrl,
          'event': 'lbxFilterSearch',
          'filter': filteredOptions
          });

          this.lastFilteredOptions = Object.keys(filteredOptions).reduce((acc, key) => {
            acc[key] = filteredOptions[key].toUpperCase(); // Convertir a mayúsculas
            return acc;
          }, {});

        }
      }else{
        if(Object.keys(filteredOptions).length <= 0) {
          if(!fullUrl){
            fullUrl = window.location.href;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'url': fullUrl,
          'event': 'lbxFilterSearch',
          'filter': {condition: this.gutembergOptions.status}
          });

          this.lastFilteredOptions = {condition: this.gutembergOptions.status.toUpperCase()};
        }
      }
    },
    clearParameters(url, keepSort = true) {
      const hasNew = url.includes('/new/');
      const hasConditionNew = url.includes('/condition/new/');

      const isNewUrl = hasNew && !hasConditionNew;

      const baseMatch = url.match(isNewUrl ? /(\/new\/[^/]+\/)/ : /(\/[^/]+\/)/);
      
      if (!baseMatch) {
        return `/${this.slug}/`;
      }
      
      const baseUrl = baseMatch[1];
      const sortBy = url.match(/sort_by\/[^/]+/);
      const sortOrder = url.match(/sort_order\/[^/]+/);
      
      let resultUrl = baseUrl;
      
      if (sortBy && sortOrder && keepSort) {
        resultUrl += `${sortBy[0]}/${sortOrder[0]}/`;
      }
      
      return resultUrl;
    },
    restoreUrl() {
      this.buildUrl(false);
      history.replaceState({}, null, this.urlToGo);
    },
    clear() {
      this.clearing = true;
      EventBus.$emit('CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION');
      EventBus.$emit('CLEAR_ALL_SEARCHABLES_SELECTION');
      this.stockNumber = "";
      this.filterValue = "";
      this.$refs.toggleListSort.clear();  // aqui da error ??
      this.dryweightRange = [this.minDryweight, this.maxDryweight];
      this.grossweightRange = [this.minGrossweight, this.maxGrossweight];
      this.sleepcapacityRange = [this.minSleepcapacity, this.maxSleepcapacity];
      this.mileageRange = [this.minMileage, this.maxMileage];
      this.priceRange = [this.minPrice, this.maxPrice];
      this.carprooflinkRange = [this.minCarprooflink, this.maxCarprooflink];
      this.paymentRange = [this.minPayment, this.maxPayment];
      this.tags = [];
      this.payloadtags = [];
      //this.updateRangeLimits();
      this.pivotList = [];
      this.updateVehiclesCount();
      this.restoreUrl();
      this.clearing = false;
    },
    clearPrice() {
      this.priceRange = [this.minPrice, this.maxPrice];
    },
    clearMileage() {
      this.mileageRange = [this.minMileage, this.maxMileage];
    },
    clearCarprooflink() {
      this.carprooflinkRange = [this.minCarprooflink, this.maxCarprooflink];
    },
    clearPayment() {
      this.paymentRange = [this.minPayment, this.maxPayment];
    },
    updateVehiclesCount() {
      this.sendSignalToInventory();
      this.filteredInventory = EventBus.postFilterInventory(this.initialResultset, this.filteringPayload);
      this.updateOptions();
      this.vehiclesCount = this.filteredInventory.length;
      this.updateRangeLimits();
      
      if(this.minPayment == 0 && this.maxPayment == 0){ 
        this.getPaymentRange();
      }
    },
    refreshSliders() {
      Object.keys(this.$refs).forEach(ref => {
        const slider = this.$refs[ref];
    
        if (slider && typeof slider.refresh === 'function') {
          slider.refresh();
          slider.unbindEvents();
          slider.bindEvents();
        }
    
        // Forzar la reasignación de eventos de touch/drag si es necesario
        if (slider && typeof slider.addEventListener === 'function') {
          slider.addEventListener('touchstart', this.handleTouchStart);
          slider.addEventListener('mousedown', this.handleMouseDown);
        }
      });
    },
    updateRangeLimits() {
      //refresh the range limits
      if (this.$refs.minPrice) this.$refs.minPrice.innerHTML = this.formatter(this.priceRange[0]);
      if (this.$refs.maxPrice) this.$refs.maxPrice.innerHTML = this.formatter(this.priceRange[1]);
      if (this.$refs.minPriceMobile) this.$refs.minPriceMobile.innerHTML = this.formatter(this.priceRange[0]);
      if (this.$refs.maxPriceMobile) this.$refs.maxPriceMobile.innerHTML = this.formatter(this.priceRange[1]);

      if (this.$refs.minMileage) this.$refs.minMileage.innerHTML = this.mileageformatter(this.mileageRange[0]);
      if (this.$refs.maxMileage) this.$refs.maxMileage.innerHTML = this.mileageformatter(this.mileageRange[1]);
      if (this.$refs.minMileageMobile) this.$refs.minMileageMobile.innerHTML = this.mileageformatter(this.mileageRange[0]);
      if (this.$refs.maxMileageMobile) this.$refs.maxMileageMobile.innerHTML = this.mileageformatter(this.mileageRange[1]);

      if (this.$refs.minCarprooflink) this.$refs.minCarprooflink.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[0]);
      if (this.$refs.maxCarprooflink) this.$refs.maxCarprooflink.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[1]);
      if (this.$refs.minCarprooflinkMobile) this.$refs.minCarprooflinkMobile.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[0]);
      if (this.$refs.maxCarprooflinkMobile) this.$refs.maxCarprooflinkMobile.innerHTML = this.carprooflinkformatter(this.carprooflinkRange[1]);

      if (this.$refs.minPayment) this.$refs.minPayment.innerHTML = this.formatter(this.paymentRange[0]);
      if (this.$refs.maxPayment) this.$refs.maxPayment.innerHTML = this.formatter(this.paymentRange[1]);
      if (this.$refs.minPaymentMobile) this.$refs.minPaymentMobile.innerHTML = this.formatter(this.paymentRange[0]);
      if (this.$refs.maxPaymentMobile) this.$refs.maxPaymentMobile.innerHTML = this.formatter(this.paymentRange[1]);

    },
    formatter(value) {
      var digits = 0;
      var formatter = new Intl.NumberFormat("en-CA", {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      });
      value = (digits != 0) ? formatter.format(value) : formatter.format(Math.floor(value));

      if (this.language == 'fr_CA') {
        return value;
      }
      else {
        return value;
      }
    },
    mileageformatter(value) {

      const formatter = new Intl.NumberFormat("en-CA", {
        style: 'unit',
        unit: 'kilometer'
      });

      return formatter.format(Math.floor(value));
    },
    dryweightformatter(value) {
      return `${value} lbs.`
    },
    sleepcapacityformatter(value) {
      return `${value} Sleeps`
    },
    carprooflinkformatter(value) {
      return `${value} Kgs.`
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    filterInventory(makes, models, inventory) {
      var filteredInventory = [];
      Object.values(inventory).forEach(item => {
        var filter = true;
        if (filter && makes.length > 0 &&
          makes.indexOf(item.make.toUpperCase()) == -1) {
          filter = false
        }
        if (filter && models.length > 0 &&
          models.indexOf(item.model.toUpperCase()) == -1) {
          filter = false
        }
        if (filter) {
          filteredInventory.push(item);
        }
      })
      return filteredInventory;
    },
    updateOptions() {

      if (this.filteredInventory) {
        if (this.filteredInventory.length > 0) {
          this.options = this.getOptions(this.filteredInventory);
          this.buildUrl();
          history.replaceState({}, null, this.urlToGo);
        } else {
          this.options = this.clearOptions();
        }

      }
    },
    sendSignalToInventory() {
      EventBus.$emit('filterInventory', this.filteringPayload);
      this.validatePriceRange();
    },
    validatePriceRange() {

      var payloadPrice = {
        "component": "priceRange",
        "selected": "Price $" + this.filteringPayload.priceRange[0] + " - $" + this.filteringPayload.priceRange[1],
        "status": true
      }

      var payloadMileage = {
        "component": "mileageRange",
        "selected": "Mileage " + this.filteringPayload.mileageRange[0] + "km - " + this.filteringPayload.mileageRange[1] + "km",
        "status": true
      }

      var payloadCarprooflink = {
        "component": "carprooflinkRange",
        "selected": "Towing Capacity " + this.filteringPayload.carprooflinkRange[0] + "Kgs. - " + this.filteringPayload.carprooflinkRange[1] + "Kgs.",
        "status": true
      }

      var payloadPayment = {
        "component": "paymentRange",
        "selected": "Payment $" + this.filteringPayload.paymentRange[0] + " - $" + this.filteringPayload.paymentRange[1],
        "status": true
      }  

      if ((this.filteringPayload.priceRange[0] + this.filteringPayload.priceRange[1]) != (this.minPrice + this.maxPrice)) {
        if (!this.tags.includes(payloadPrice.selected)) {
          if (payloadPrice.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Price ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadPrice.selected);
            this.payloadtags.push(payloadPrice);
          }
        }
      }

      if ((this.filteringPayload.carprooflinkRange[0] + this.filteringPayload.carprooflinkRange[1]) != (this.minCarprooflink + this.maxCarprooflink)) {
        if (!this.tags.includes(payloadCarprooflink.selected)) {
          if (payloadCarprooflink.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Towing ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadCarprooflink.selected);
            this.payloadtags.push(payloadCarprooflink);
          }
        }
      }

      if ((this.filteringPayload.paymentRange[0] + this.filteringPayload.paymentRange[1]) != (this.minPayment + this.maxPayment)) {
        if (!this.tags.includes(payloadPayment.selected)) {
          if (payloadPayment.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Payment ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadPayment.selected);
            this.payloadtags.push(payloadPayment);
          }
        }
      }

      if ((this.filteringPayload.mileageRange[0] + this.filteringPayload.mileageRange[1]) != (this.minMileage + this.maxMileage)) {
        if (!this.tags.includes(payloadMileage.selected)) {
          if (payloadMileage.status) {

            for (var i = 0; i < this.tags.length; i++) {
              if (this.tags[i].includes("Mileage ")) {
                this.tags.splice(i, 1);
                this.payloadtags.splice(i, 1);
              }
            }
            this.tags.push(payloadMileage.selected);
            this.payloadtags.push(payloadMileage);
          }
        }
      }

    },
    makeChanged(selected, clear = true) {
      if (selected.length == 0) {
        this.$refs.modelToggleList.show = false;
        this.$refs.modelToggleList.enable = true;

        this.postOptions.models = [];
        this.postOptions.trims = [];
      }
      else {
        if (this.$refs.modelToggleList && clear)
          this.$refs.modelToggleList.clearSelection();

        if(this.urlParams.makes === undefined)
          this.$refs.modelToggleList.show = true;

        this.$refs.modelToggleList.enable = true;
        var options = this.getOptions(this.filteredInventory);
        this.postOptions.models = options.models;
      }
    },
    modelChanged(selected) {
      if (selected.length == 0) {
        this.$refs.trimToggleList.show = false;
        this.$refs.trimToggleList.enable = false;
        this.pleaseSelectAModel = true;
        this.$refs.trimToggleList.clearSelection();
        this.removeComponentTypeTags("trim");
      }
      else {
        if(this.urlParams.models === undefined)
          this.$refs.trimToggleList.show = true;

        this.$refs.trimToggleList.enable = true;
        this.pleaseSelectAModel = false;
      }
    },
    updateTags(payload) {
      if (!this.tags.includes(payload.selected.toLowerCase())) {
        if (payload.status) {
          this.tags.push(payload.selected.toLowerCase());
          this.payloadtags.push(payload);
        }
      } else {
        if (!payload.status) {
          for (var i = 0; i < this.tags.length; i++) {
            if (this.tags[i].toLowerCase() == payload.selected.toLowerCase()) {
              this.tags.splice(i, 1);
              this.payloadtags.splice(i, 1);
            }
          }

        }
      }
    },
    checkTagType(item) {
      if (item === '1') {
        return "Demo";
      } else {
        return item;
      }
    },
    removeConditionTag(item) {
      for (var i = 0; i < this.tags.length; i++) {
        if (this.tags[i].toUpperCase() == item.toUpperCase()) {
          this.tags.splice(i, 1);
          this.payloadtags.splice(i, 1);
        }
      }
      this.updateVehiclesCount();
    },
    removeComponentTypeTags(componentType) {
      for (var i = 0; i < this.payloadtags.length; i++) {
        if (this.payloadtags[i].component == componentType) {
          this.payloadtags.splice(i, 1);
          this.tags.splice(i, 1);
          i--;
        }
      }
    },
    normalizeString(str) {
      return str.replace(/-/g, '').replace(/\s+/g, '').toLowerCase();
    },
    searchVehicle(query, vehicleList) {
      const normalizedQuery = this.normalizeString(query);
      return vehicleList.some(vehicle => this.normalizeString(vehicle) === normalizedQuery);
    },
    searchVehicleIndex(query, vehicleList) {
      const normalizedQuery = this.normalizeString(query);
    
      return vehicleList.findIndex(vehicle => this.normalizeString(vehicle) === normalizedQuery);
    },
    removeVehicle(query, vehicleList) {
      const index = this.searchVehicleIndex(query, vehicleList);
      if (index !== -1) {
        vehicleList.splice(index, 1);
      }
    },
    removeTag(item){
      var component;
      var payload;

      if(item)
      for(var i = 0; i < this.tags.length; i++) {
        if(this.tags[i] == item){
          this.tags.splice(i, 1);
          component = this.payloadtags[i].component;
          this.payloadtags.splice(i, 1);
        }
      }
   
      if(item && component){
        if(component == "priceRange"){
          this.priceRange = [this.minPrice,this.maxPrice];
          payload={'component':component, 'selected':[]}
        }else if(component == "mileageRange"){
          this.mileageRange = [this.minMileage,this.maxMileage];
          payload={'component':component, 'selected':[]}
        }else if(component == "carprooflinkRange"){
          this.carprooflinkRange = [this.minCarprooflink,this.maxCarprooflink];
          payload={'component':component, 'selected':[]}
        } else if(component == "paymentRange"){
          this.paymentRange = [this.minPayment,this.maxPayment];
          payload={'component':component, 'selected':[]}
        }else{
          if(this.searchVehicle(item, this.selected[component]))
            this.removeVehicle(item, this.selected[component]);
  
          payload = {'component':component, 'selected':this.selected[component]}
        }    
        
        this.pivoting(payload); //With this reorder the pivot list to refresh the options
        //this.updateVehiclesCount();
        // with this te TRim select list is disabled when remove model filter. //By Pablo May-23
        if(component == "model") {
          this.modelChanged(this.selected[component]);    
        }
        if(component == "make") {
          this.makeChanged(this.selected[component]);
        }
        payload = { 'component': component, 'selected': this.selected[component] }
      }
    },
    removeAllTags() {
      this.initialZero = false;
      this.tags = [];
      this.payloadtags = [];
      this.clear();
    },
    removeTagNull(component){
      
      var components = component === 'status' ? component : `${component}s`;
      var optionsAvalaible = this.options[components];
      var tagFound = false;

      for (var i = 0; i < this.payloadtags.length; i++) {
        if (this.payloadtags[i].component == component) {
          tagFound = false;
          for(var j = 0; j < optionsAvalaible.length; j++) {
            if(this.payloadtags[i].selected.toUpperCase().replace(/[\s-]/g, "") == optionsAvalaible[j].toUpperCase().replace(/[\s-]/g, "")){
              tagFound = true;
            }
          }
          if (!tagFound) {
            this.removeTag(this.payloadtags[i].selected);
          }
        }
      }

    },
    updateChecked(payload) {
      if (this.vehiclesCount > 0 || Object.keys(payload.selected).length > 0 || !this.initialZero) {

        this.removeTagNull(payload.component);
        this.selected[payload.component] = payload.selected
        this.pivoting(payload);
        //this.updateVehiclesCount()
        if (payload.component == 'model') {
          if(Object.keys(this.optionsCount.models).length === 1){
            this.modelChanged(Object.keys(this.optionsCount.models)[0]);
            this.$refs.modelToggleList.enable = false;
          }else{
            this.modelChanged(payload.selected);
          }
        }
        if (payload.component == 'make') {
          this.makeChanged(payload.selected);
          
        }
      }
    },
    search() {
      if (this.vehiclesCount > 0) {
        this.buildUrl();
        this.setSessionStorage();
        window.location.href = this.urlToGo;
      }
    },
    pivoting(payload) {
      var component = `${payload.component}s`;
      var index = this.pivotList.indexOf(component);
      if (payload.selected.length == 0 && index != -1)
        this.pivotList.splice(index, 1);
      else if (payload.selected.length > 0 && index == -1)
        this.pivotList.push(component);

      this.updateVehiclesCount();

    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    getSelectedFromSessionStorage() {
      return JSON.parse(sessionStorage.getItem('selected'));
    },
    setSessionStorage() {
      sessionStorage.clear();
      sessionStorage.setItem('slug', this.slug);
      sessionStorage.setItem('selected', JSON.stringify(this.selected))
    },
    searchStatusInInventory(status){
      var inventory = this.initialResultset;
      var total = 0;
      inventory.forEach((item) => {
        if(status == 'certified' && item.certified)
          total++;
        else if(status == 'demo' && item.demo)
          total++;
        else if(status == 'asis' && item.asis)
          total++;
        else if(status == 'salepending' && item.salepending)
          total++;
        else if(status == 'special' && item.special)
          total++;
        else if(status == 'new' && item.condition == 'New')
          total++;
        else if(status == 'used' && item.condition == 'Used')
          total++;
      })

      return total;
    }
  },
  computed: {
    initialMakes() {
      return this.urlParams.makes || [];
    },
    initialLots() {
      return this.urlParams.lots || [];
    },
    initialModels() {
      return this.urlParams.models || [];
    },
    initialTrims() {
      return this.urlParams.trims || [];
    },
    initialColours() {
      return this.urlParams.color || [];
    },
    initialBodystyles() {
      return this.urlParams.bodystyles || [];
    },
    initialFueltypes() {
      return this.urlParams.fueltypes || [];
    },
    initialConditions() {
      return this.urlParams.conditions || [];
    },
    initialYears() {
      return this.urlParams.years || [];
    },
    initialSalependings() {
      return this.urlParams.salependings || [];
    },
    initialDemos() {
      return this.urlParams.demos || [];
    },
    initialAsis() {
      return this.urlParams.asiss || [];
    },
    initialCertifieds() {
      return this.urlParams.certifieds || [];
    },
    initialSpecials() {
      return this.urlParams.specials || [];
    },
    initialStocks() {
      return this.urlParams.stocks || [];
    },
    initialFeatures() {
      return this.urlParams.searchables || [];
    },
    initialEnginedisplacements() {
      return this.urlParams.enginedisplacements || [];
    },
    initialPackages() {
      return this.urlParams.package || [];
    },
    initialLocations() {
      return this.urlParams.locations || [];
    },
    initialEngines() {
      return this.urlParams.engines || [];
    },
    initialDrivetrains() {
      return this.urlParams.drivetrains || [];
    },
    initialBoxsizes() {
      return this.urlParams.boxsizes || [];
    },
    initialTransmissions() {
      return this.urlParams.transmissions || [];
    },
    initialStatus() {
      return this.urlParams.status || [];
    },
    initialTypes() {
      return this.urlParams.types || [];
    },
    initialSubTypes() {
      return this.urlParams.types || [];
    },
    initialProductlines() {
      return this.urlParams.productlines || [];
    },
    initialOutsideLengths() {
      return this.urlParams.outsidelength || [];
    },
    initialFloorPlans() {
      return this.urlParams.floorplans || [];
    },
    initialSeats() {
      return this.urlParams.seats || [];
    },
    filteringPayload() {
      return {
        stockNumber: this.stockNumber,
        mileageRange: this.mileageRange,
        priceRange: this.priceRange,
        carprooflinkRange: this.carprooflinkRange,
        paymentRange: this.paymentRange,
        dryweightRange: this.dryweightRange,
        grossweightRange: this.grossweightRange,
        sleepcapacityRange: this.sleepcapacityRange,
        filterValue: this.filterValue,
        selected: this.selected,
        minMileage: this.minMileage,
        maxMileage: this.maxMileage,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        minCarprooflink: this.minCarprooflink,
        maxCarprooflink: this.maxCarprooflink,
        minPayment: this.minPayment,
        maxPayment: this.maxPayment,
        minDryweight: this.minDryweight,
        maxDryweight: this.maxDryweight,
        minGrossweight: this.minGrossweight,
        maxGrossweight: this.maxGrossweight,
        minSleepcapacity: this.minSleepcapacity,
        maxSleepcapacity: this.maxSleepcapacity,
        paymentFrequency: this.paymentFrequency,
        page: 1,
      }
    }
  },
  watch: {
    priceRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.priceRange[0] == this.priceInitialRange[0] && this.priceRange[1] == this.priceInitialRange[1]) {
        //* Buscar el tag que incluya "price"
        const priceTag = this.tags.find(tag => tag.toLowerCase().includes('price'));
        if (priceTag) {
          this.removeTag(priceTag);
        }
      }
    },
    mileageRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.mileageRange[0] == this.mileageInitialRange[0] && this.mileageRange[1] == this.mileageInitialRange[1]) {
        //* Buscar el tag que incluya "mileage"
        const mileageTag = this.tags.find(tag => tag.toLowerCase().includes('mileage'));
        if (mileageTag) {
          this.removeTag(mileageTag);
        }
      }
    },
    carprooflinkRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      if (this.carprooflinkInitialRange[0] && this.carprooflinkInitialRange[1] && this.carprooflinkRange[0] == this.carprooflinkInitialRange[0] && this.carprooflinkRange[1] == this.carprooflinkInitialRange[1]) {
        //* Buscar el tag que incluya "carprooflink"
        const carprooflinkTag = this.tags.find(tag => tag.toLowerCase().includes('towing'));
        if (carprooflinkTag) {
          this.removeTag(carprooflinkTag);
        }
      }
    },
    paymentRange(o, n) {    
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount();
      
      if (this.minPayment && this.maxPayment && this.paymentRange[0] == this.minPayment && this.paymentRange[1] == this.maxPayment) {
        //* Buscar el tag que incluya "payment"
        const paymentTag = this.tags.find(tag => tag.toLowerCase().includes('payment'));
        if (paymentTag) {
          this.removeTag(paymentTag);
        }
      }
    },
    dryweightRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    grossweightRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    sleepcapacityRange(o, n) {
      if (!(o[0] == n[0] && o[1] == n[1]))
        this.updateVehiclesCount()
    },
    loadingInventory(newVal) {
      if(newVal == true)
        EventBus.$emit('variablesUpdate', { loadingInventory: true });
      else
        EventBus.$emit('variablesUpdate', { loadingInventory: false });
    },
    searchOpened(newVal) {
      if(newVal == true)
        EventBus.$emit('variablesUpdate', { searchOpened: true });
      else
        EventBus.$emit('variablesUpdate', { searchOpened: false });
    },  
    selected(newVal) {
      EventBus.$emit('variablesUpdate', { selected: newVal });
    },
    minPayment(newVal) {
      EventBus.$emit('variablesUpdate', { minPayment: newVal });
    },
    maxPayment(newVal) {
      EventBus.$emit('variablesUpdate', { maxPayment: newVal });
    },
    vehiclesCount(newVal) {
      EventBus.$emit("variablesUpdate", { vehiclesCount: newVal });
    },
    inStockCount(newVal) {
      EventBus.$emit("variablesUpdate", { inStockCount: newVal });
    },
    incomingCount(newVal) {
      EventBus.$emit("variablesUpdate", { incomingCount: newVal });
    },
    window: {
      deep: true,
      handler(val) {
        if (val.width <= 1024)
          this.isMobile = true;
        else
          this.isMobile = false;

        if(val.width < 1280)
          this.isTablet = true;
        else
          this.isTablet = false;
      }
    }
  }
}
